import { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { TfiLocationPin } from 'react-icons/tfi';
import { MdArrowOutward } from 'react-icons/md';
import { Button } from '../../../UI/Button/Button';
import ContactModal from '../../../UI/Modal/ContactModal/ContactModal';
import GamesModal from '../../../UI/Modal/GameModal/Modal';
import style from './card.module.css';

const Card = ({ item }) => {
  const [dataPrice, setDataPrice] = useState([]);
  const [dataType, setDataType] = useState({});
  const [modalAboutIsOpen, setAboutModal] = useState(false);
  const [modalIsOpen, setModal] = useState(false);
  const navigate = useNavigate();

  // Запуск анимации
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Получение данных из API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/2');
        const result = await response.json();
        setDataPrice(result);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      }
    };

    fetchData();
  }, []);

  // Фильтрация данных
  const typeFilter = useMemo(() => {
    return dataPrice.filter((card) => card.key_id === item.key_id);
  }, [dataPrice, item.key_id]);

  // Обработчик навигации
  const handelNavigation = useCallback(
    (id) => {
      navigate(`/arenas/${id}`);
    },
    [navigate]
  );

  // Открытие модального окна о площадке
  const handelAboutModal = useCallback(
    (n) => {
      setDataType(typeFilter.find((card) => card.Name === n));
      setAboutModal((prev) => !prev);
      document.body.style.overflow = modalAboutIsOpen ? 'visible' : 'hidden';
    },
    [modalAboutIsOpen, typeFilter]
  );

  // Закрытие модального окна
  const closeModal = useCallback(() => {
    setDataType({});
    setAboutModal(false);
    document.body.style.overflow = 'visible';
  }, []);

  // Обработчик для модала
  const handelModal = useCallback(() => {
    setModal((prev) => !prev);
    document.body.style.overflow = modalIsOpen ? 'visible' : 'hidden';
  }, [modalIsOpen]);

  // Динамическое создание слайдов
  const images = [
    item.img1,
    item.img2,
    item.img3,
    item.img4,
    item.img5,
    item.img6,
    item.img7,
    item.img8,
  ];

  return (
    <>
      <div
        className={style.content}
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className={style.left}>
          <Swiper
            loop={true}
            spaceBetween={10}
            navigation={true}
            modules={[Navigation, Thumbs]}
            slidesPerView={1.05}
            grabCursor={true}
            className={style.imgSlider}
          >
            {images.filter(Boolean).map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={`./imgs/playground/${img}`}
                  alt={`Slide ${index + 1}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className={style.right}>
          <div className={style.title}>
            {item.Type && (
              <span className={style.subtitle}>{item.Type} Площадка</span>
            )}
            <h3>{item.Name}</h3>
            <span className={style.text}>{item.Description}</span>
          </div>

          <div className={style.desc}>
            <ul>
              {item.Quanty && (
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  <span>{item.Quanty}</span>
                </li>
              )}
              {item.Relax && (
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  <span>{item.Relax}</span>
                </li>
              )}
            </ul>
            <ul>
              {item.Loc && (
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  <span>{item.Loc}</span>
                </li>
              )}
              {item.Parking && (
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  <span>{item.Parking}</span>
                </li>
              )}
            </ul>
          </div>

          <div className={style.games}>
            <ul className={style.price}>
              {item.PriceLazer && (
                <li onClick={() => handelAboutModal('Лазертаг')}>
                  <span className={style.gameName}>Лазертаг</span>
                  <div></div>
                  <b>{item.PriceLazer}</b>
                  <button>Подробнее</button>
                </li>
              )}
              {item.PriceGidra && (
                <li onClick={() => handelAboutModal('Гидробол')}>
                  <span className={style.gameName}>Гидробол</span>
                  <div></div>
                  <b>{item.PriceGidra}</b>
                  <button>Подробнее</button>
                </li>
              )}
              {item.PricePeint && (
                <li onClick={() => handelAboutModal('Пейнтбол')}>
                  <span className={style.gameName}>Пейнтбол</span>
                  <div></div>
                  <b>{item.PricePeint}</b>
                  <button>Подробнее</button>
                </li>
              )}
              {item.Skypark && (
                <li onClick={() => handelAboutModal('Скайпарк')}>
                  <span className={style.gameName}>Скайпарк</span>
                  <div></div>
                  <b>{item.Skypark}</b>
                  <button>Подробнее</button>
                </li>
              )}
            </ul>
          </div>

          <div className={style.buttons}>
            <div>
              <a href="tel:+78432587427">
                <Button text="Забронировать" type={false} />
              </a>
            </div>
            {item.Url_address && (
              <div className={style.location}>
                <a href={item.Url_address} target="_blanck">
                  <Button icon={<TfiLocationPin />} />
                </a>
              </div>
            )}
            <div onClick={() => handelNavigation(item.seo_url)}>
              <Button icon={<MdArrowOutward />} type={false} />
            </div>
          </div>
        </div>
      </div>

      <GamesModal
        dataType={dataType}
        modalAboutIsOpen={modalAboutIsOpen}
        closeModal={closeModal}
      />
      <ContactModal modalIsOpen={modalIsOpen} handelModal={handelModal} />
    </>
  );
};

export default Card;
